/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  parentForm: Object,
  model: Object,
  localState: Object,
  fields: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewProjectSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, parentForm, model, localState, fields }: TypeProps = this.props;

    if (fields.project) {
      const field: Object = parentForm.$(`${fields.project}`);
      const fieldExtra: Object = field.extra;

      field.set('value', actionDrawerStore.response.name);
      field.set('extra', { ...fieldExtra, selectID: actionDrawerStore.response.id });

      if (localState && typeof localState.selectedValuePrjc !== 'undefined') {
        localState.selectedValuePrjc === ''
          ? (localState.selectedValuePrjc = actionDrawerStore.response.id)
          : (localState.selectedValuePrjc = `${localState.selectedValuePrjc},${
              actionDrawerStore.response.id
            }`);

        field.set('value', localState.selectedValuePrjc);
      }

      model.loadData();
    }

    actionDrawerStore.closeActionDrawer();
  }

  render() {
    return 'success';
  }
}
